import { ThemeOptions } from '@material-ui/core/styles'

const imagePath = '/static/images/standalone/engaging/'

/**
 * engaging Standalone Theme
 */
const EngagingTheme: ThemeOptions = {
  typography: {
    fontFamily: 'Hiragino Kaku Gothic Pro',
    h1: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '18px',
    },
    h2: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '16px',
    },
    h3: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '14px',
    },
    subtitle1: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '12px',
    },
    subtitle2: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '11px',
    },
    body1: {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '14px',
    },
    body2: {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '12px',
    },
    button: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '16px',
    },
    caption: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '10px',
    },
    overline: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '9px',
    },
  },
  palette: {
    primary: {
      main: '#EB6E8F',
      dark: '#C85271',
    },
    secondary: {
      main: '#C6A853',
      light: '#F2EAD4',
    },
    grey: {
      50: '#FAFAFA',
      100: '#F5F5F5',
      200: '#EEEEEE',
      300: '#EEEEEE',
      400: '#BDBDBD',
      500: '#9E9E9E',
      600: '#9E9E9E',
      700: '#616161',
      800: '#424242',
      900: '#212121',
    },
    info: {
      main: '#FFC0DE',
    },
    error: {
      main: '#FF0000',
    },
    text: {
      primary: '#444444',
      secondary: '#999999',
    },
    textLight: {
      primary: '#FFFFFF',
    },
    background: {
      primary: '#F6F3EC',
      secondary: '#FFFFFF',
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 28,
        paddingTop: 12,
        paddingBottom: 12,
      },
      sizeSmall: {
        paddingTop: 8,
        paddingBottom: 8,
      },
      outlined: {
        paddingTop: 12,
        paddingBottom: 12,
        color: '#C85271',
        borderColor: '#EB6E8F',
      },
    },
    MuiListItem: {
      container: {
        listStyleType: 'none',
      },
    },
  },
  shadows: [
    'none',
    '0px 4px 8px rgba(0,0,0,0.08)',
    '0px 8px 16px -8px rgba(0,0,0,0.32)',
    '0px 12px 24px -12px rgba(0,0,0,0.56)',
    '0px 24px 48px -24px rgba(0,0,0,0.8)',
    '0px 24px 48px -24px rgba(0,0,0,0.8)',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  shape: {
    borderRadius: 4,
  },
  props: {
    MuiTypography: {},
    MuiAppBar: {
      elevation: 0,
    },
    MuiInputLabel: {},
  },
  assets: {
    menuIcon: {
      collection: imagePath + 'menuicon/collection.png',
    },
    collection: {
      secret: imagePath + 'collection/secret.png',
    },
    backgrounds: {
      signup: imagePath + 'backgrounds/signup.jpg',
      home: imagePath + 'backgrounds/home.jpg',
      collections: {
        V83GiNkw8Dd7psxAgYo8:
          imagePath + 'backgrounds/collections/V83GiNkw8Dd7psxAgYo8.jpg',
      },
      items: {
        V83GiNkw8Dd7psxAgYo8:
          imagePath + 'backgrounds/items/V83GiNkw8Dd7psxAgYo8.jpg',
      },
    },
    logoMedium: imagePath + 'logo_medium.png',
    logoMediumReverse: imagePath + 'logo_medium_reverse.png',
    logoSmall: imagePath + 'logo_small.png',
    logoSmallReverse: imagePath + 'logo_small_reverse.png',
  },
  customStyle: {
    VoiceIcon: {
      innerCircle: {
        border: '1px dashed #FFFFFF',
        borderRadius: '50%',
      },
    },
    Chip: (colorCode = '#7CA3DD'): React.CSSProperties => {
      return {
        backgroundColor: colorCode,
      }
    },
    ErrorBase: {
      background: {
        right: 0,
      },
    },
  },
}

export default EngagingTheme
